import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { STRING_CONSTANT } from "../../constants/constants";
import {
  getConferenceConfiguration,
  getConferenceDetails,
  getConferenceDocuments,
  getConferenceSubscription,
  getKUConfiguration,
  getKUPaperFeesMapping,
} from "../../redux/features/conference-details/conferenceSlice";
import { isConfrenceEnded } from "../../utils/util";
import ConferenceCarousel from "../carousel/index";
import ConferenceErrorDiv from "../common/conference-error-div";
import ConferenceRegistrationDetails from "./conference-registration-details";
import ConferenceRegistrationForm from "./conference-registration-form/index";
import SuccessResponse from "./conference-registration-response/success-response";

const ConferenceRegistration = () => {
  const [token, setToken] = useState(null);
  const [isPaidRegistration, setIsPaidRegistration] = useState(false);
  const [isTokenValid, setIstokenValid] = useState(false);
  const dispatcher = useDispatch();
  const { id, registrationNumberPrefix } = useParams();
  const { conferenceDetails, conferenceFeesList, conferenceConfiguration } = useSelector(
    (state) => state.conferenceDetails
  );
  const { payment } = useSelector((state) => state.confRegistration);

  const ErrorMessageComponent = ({ errorMessage }) => {
    // Function to extract the message after the first hyphen "-"
    const extractMessage = (message) => {
      const parts = message.split('-');
      return parts.length > 1 ? parts.slice(1).join('-') : '';
    };
  
    const extractedMessage = extractMessage(errorMessage);
  
    return (
        <div className="row justify-content-center align-items-center">
          <div className="col-auto text-center p-3">
            {extractedMessage}
          </div>
        </div>
    );
  };

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split(STRING_CONSTANT.QUESTION)[1]);
    const tokenValue = params.get("token");
    setToken(tokenValue);
    dispatcher(getKUConfiguration());
  }, []);

  useEffect(() => {
    const isPaid = token === null;
    setIsPaidRegistration(isPaid);
    if (!isPaid) {
      setIstokenValid(conferenceDetails?.token === token);
    } else {
      setIstokenValid(true);
    }
  }, [token, conferenceDetails]);

  useEffect(() => {
    if (id && registrationNumberPrefix) {
      let payload = {
        id: id,
        registrationNumberPrefix: registrationNumberPrefix,
      };
      dispatcher(getConferenceDetails(payload));
    }
  }, [id, registrationNumberPrefix]);

  useEffect(() => {
    if (payment) {
      //Redirect user to error page.
      console.error("Something went wrong", payment?.Status);
    }
  }, [payment]);

  useEffect(() => {
    if (conferenceDetails) {
      let payload = {
        id: id,
      };
      dispatcher(getConferenceDocuments(payload));
      dispatcher(getConferenceSubscription(payload));
      dispatcher(getKUPaperFeesMapping(payload));
      dispatcher(getConferenceConfiguration(payload));
    }
  }, [conferenceDetails]);

  return (
    <>
      {conferenceDetails &&
        (payment && payment?.Status === "Paid" ? (
          <SuccessResponse payment={payment} />
        ) : ((payment && payment?.Status === "Error" && payment?.ErrorMessage !== "") ? (
            <ErrorMessageComponent errorMessage={payment?.ErrorMessage} />
        ) : (
          <>
            <ConferenceCarousel />
            <div className="container mt-5 pb-5 mb-5">
              <div className="row">
                <ConferenceRegistrationDetails
                  conferenceDetails={conferenceDetails}
                  conferenceFeesList={conferenceFeesList}
                  isPaidRegistration={isPaidRegistration}
                  conferenceConfiguration={conferenceConfiguration}
                />
                <div className="col-lg-1"></div>
                <div className="col-lg-3" id="register-form">
                  {isTokenValid ? (
                    conferenceDetails.enabled &&
                    isConfrenceEnded(conferenceDetails.toDate) ? (
                      <div className="rounded overflow-hidden">
                        <h5 className="color-dark bg-light-2 mb-0 p-3">
                          {t("fill-details-to-register")}
                        </h5>
                        <div className="p-4 bg-light ">
                          <ConferenceRegistrationForm
                            conferenceDetails={conferenceDetails}
                            conferenceFeesList={conferenceFeesList}
                            isPaidRegistration={isPaidRegistration}
                          />
                        </div>
                      </div>
                    ) : (
                      <ConferenceErrorDiv message={t("conference-close-message")}/>
                    )
                  ) : (
                    <ConferenceErrorDiv message={t("invalid-token")}/>
                  )}
                </div>
              </div>
            </div>
          </>
        )))}
    </>
  );
};

export default ConferenceRegistration;
